import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Button from '@segment/matcha/components/Button'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

const copy = {
  heading: `Looking for a partner to help you implement Segment?`,
}

const link = {
  text: `Find a Partner`,
  url: `https://segment.partnerpage.io/`,
}

const LookingForPartner: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <SectionBase variant="noCopy">
        <Section.Contents>
          <StyledCopyTextBase centered={true}>
            <StyledCopyTextHeading>{copy.heading}</StyledCopyTextHeading>
            <Button href={link.url} color="primary" size="large" variant="filled">
              {link.text}
            </Button>
          </StyledCopyTextBase>
        </Section.Contents>
      </SectionBase>
    </Wrapper>
  )
}

const StyledCopyTextHeading = styled(CopyText.Heading)`
  margin-bottom: 24px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    margin-bottom: 40px;
  }
`

const StyledCopyTextBase = styled(CopyTextBase)`
  max-width: 684px;
  margin: 0 auto;
`

const Wrapper = styled.div``

export default LookingForPartner
